// extracted by mini-css-extract-plugin
export var container = "SidebarLinks-module--container--b9d81";
export var player = "SidebarLinks-module--player--fa425";
export var video = "SidebarLinks-module--video--1911f";
export var videoContainer = "SidebarLinks-module--videoContainer--409ad";